export default "__VITE_ASSET__zKKarZVW__"